export default __webpack_public_path__ + "static/media/logoInverted.b991b8f3.svg";